module.exports = __webpack_public_path__ + "img/product_32.f007d07.svg";